export default function DraftIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.75 1.5V3M9 1.5V3M5.25 1.5V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.625 7.5C2.625 5.02513 2.625 3.78769 3.39385 3.01885C4.16269 2.25 5.40013 2.25 7.875 2.25H10.125C12.5998 2.25 13.8373 2.25 14.6062 3.01885C15.375 3.78769 15.375 5.02513 15.375 7.5V11.25C15.375 13.7248 15.375 14.9623 14.6062 15.7312C13.8373 16.5 12.5998 16.5 10.125 16.5H7.875C5.40013 16.5 4.16269 16.5 3.39385 15.7312C2.625 14.9623 2.625 13.7248 2.625 11.25V7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11.25H9M6 7.5H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
